module.exports = __webpack_public_path__ + "static/media/radiant-charm.e3cd1b75.png";